import React from 'react';
import BillingFeature from '../features/billing/Billing';

const BillingPage: React.FC = () => {
    return <BillingFeature />;
};

export default BillingPage;
